export default __webpack_public_path__ + "static/cliff-a765ab765b0ac4abc42ed5333386749c.svg";